import type { ReactNode } from "react";
import { useI18n } from "../i18n/I18nProvider";
import { RedLine } from "../components/rink/RedLine";
import { Panel } from "../components/ui/feedback";

/**
 * Sign-in composition: the wordmark in display caps over a board panel. The red line is the horizon
 * under the panel: full viewport width, 24px below the panel's bottom edge, with the faceoff dot at its centre.
 */
export function AuthShell({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  return (
    <div className="mx-auto flex w-full max-w-md flex-col items-center gap-6 pt-4 sm:pt-12">
      <p className="text-center font-display text-4xl leading-[0.92] font-extrabold tracking-[0.01em] text-ink uppercase sm:text-display-lg">
        {t("app.name")}
      </p>
      <div className="relative w-full pb-6">
        <Panel className="relative space-y-5 md:p-6">{children}</Panel>
        <div className="absolute bottom-0 left-1/2 w-screen -translate-x-1/2">
          <RedLine centerDot />
        </div>
      </div>
    </div>
  );
}
